import { Controller } from "@hotwired/stimulus";
import { i18n } from "../lib/i18n";

// Drives the status label on auto-saving settings cards: the resting label
// ("Saved automatically") becomes "Saving…" while a submit is in flight, then
// "Saved ✓" for a moment on success before settling back. Failures return
// straight to the resting label — the error toast carries the news.
export default class extends Controller {
  static targets = ["label"];
  static values = { holdMs: { type: Number, default: 2000 } };

  connect() {
    this.idleText = this.labelTarget.textContent.trim();
  }

  saving() {
    clearTimeout(this.timer);
    this.labelTarget.textContent = i18n.t("auto_save.saving");
  }

  settle(event) {
    if (event.detail.success) {
      this.labelTarget.textContent = i18n.t("auto_save.saved");
      this.labelTarget.classList.add("text-primary");
      this.timer = setTimeout(() => this.reset(), this.holdMsValue);
    } else {
      this.reset();
    }
  }

  reset() {
    this.labelTarget.textContent = this.idleText;
    this.labelTarget.classList.remove("text-primary");
  }

  disconnect() {
    clearTimeout(this.timer);
  }
}
